import React from 'react';

import { Box } from '@mui/material';

import { FullscreenLoader } from 'src/components/common';
import { RevenueShareCard } from 'src/components/revenueShare';
import { useCurrentUserPeoPayrollProvider } from 'src/hooks/peoPayrollProvider';
import { NotFoundErrorPage } from 'src/pages/not-found';

export const PeoPayrollProviderWallet: React.FC = () => {
  const { peoPayrollProvider, loading } = useCurrentUserPeoPayrollProvider();

  if (loading) {
    return <FullscreenLoader />;
  }

  if (!peoPayrollProvider?.revenueShareSetting) {
    return <NotFoundErrorPage />;
  }

  return (
    <Box width="50%">
      <RevenueShareCard company={peoPayrollProvider} />
    </Box>
  );
};
